// Tiny dev-only logger. Strips console noise from production builds.
// Errors that the user should see go through the toast UI, not the console.
const isDev = process.env.NODE_ENV !== 'production';

export const log = {
  info: (...args) => { if (isDev) console.info('[revcore]', ...args); },
  warn: (...args) => { if (isDev) console.warn('[revcore]', ...args); },
  error: (...args) => { if (isDev) console.error('[revcore]', ...args); },
};
